module.exports = __webpack_public_path__ + "static/media/sociability.170e99ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sociability.png
// module id = 271
// module chunks = 0